<template>
    <v-row no-gutters class="py-4 n4">
        <v-col class="py-0 totals col-6 d-flex align-center">
            <div style="min-width: 50px" class="d-flex align-center justify-center">
                <v-icon color="white">$vuetify.icons.billable</v-icon>
            </div>
            <div class="white--text">
                <div class="caption">{{ $t('Billable') }} / {{ $t('Non-billable') }}</div>
                <div class="tabular-nums subtitle-2">
                    {{ controller.model.getBillableTimeWithRunningTimeEntryBillableTime() | format_time_duration }} /
                    {{ controller.model.getNonBillableTimeWithRunningTimeEntryNonBillableTime() | format_time_duration }}
                </div>
            </div>
        </v-col>
        <v-col class="text-right pa-0 col-6 d-flex align-center justify-end" :class="isMobile ? '' : 'pr-12'">
            <div class="timer-time mr-2">
                <div
                    class="time-disp text-right white--text tabular-nums"
                    @click.stop="$emit('close')"
                >
                    <span>{{ trackedTime | format_time_duration }}</span>
                </div>
            </div>
            <v-btn
                icon
                color="white"
                @click.stop="$emit('close')"
            >
                <v-icon>mdi-chevron-up</v-icon>
            </v-btn>
        </v-col>
    </v-row>
</template>

<script>
import Controller from "./controller"

export default {
    name: "BillableHeader",
    props: {
        trackedTime: {
            type: Number,
            default: null
        },
        controller: {
            type: Controller,
            required: true
        },
        isMobile: {
            type: Boolean,
            default: null
        }
    }
}
</script>

<style scoped lang="scss">
.v-input {
    ::v-deep .v-input--switch__thumb {
        &::after {
            content: '';
            width: 16px;
            height: 16px;
            background-size: cover;
            background-image: url('~@/assets/NonBillableIcon-svg.svg');
        }
    }

    &.v-input--is-label-active {
        ::v-deep .v-input--switch__thumb {
            &::after {
                background-image: url('~@/assets/BillableIcon-svg.svg');
            }
        }
    }
}
</style>